<template>
  <div class="agent-detail h-full" v-loading="tableLoading">
    <div class="search-box">
      <div>
        <el-input v-model="inputVal" placeholder="企业名称" style="width: 188px" class="mr-3" @blur="getData"></el-input>
        <el-select v-model="selectVal" placeholder="审核状态" class="mr-3" @change="getData">
          <el-option v-for="item in selectOpt" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="handleDrawer">邀请代理商</el-button>
    </div>
    <EmptyDetail v-if="isEmpty" :handle-drawer="handleDrawer" />
    <div v-else class="table-content">
      <data-table
        ref="dataTable"
        :selection="true"
        :isShowCheckCount="true"
        :isShowCheckAll="true"
        :height="tableHeight"
        :loading="tableLoading"
        :data="tableData"
        :columns="columns"
        :page="page"
        :showPage="true"
        @selection-change="selectionChange"
        @size-change="sizeChange"
        @pagination-current-change="currentChange"
      >
        <!-- 结算方式 -->
        <template #auditStatus="{ row }">
          <Status :pointColor="row.auditStatus | textColor" :text="status[row.auditStatus]" />
        </template>

        <!-- 操作 -->
        <template #operation="{ row }">
          <el-tooltip content="仅企业管理员可编辑" placement="top" effect="light" :disabled="isAdmin" v-if="row.auditStatus">
            <div class="inline-block">
              <el-button type="text" @click="handleEditDrawer(row, 'edit')" :disabled="!isAdmin">编辑</el-button>
            </div>
          </el-tooltip>

          <el-popover
            popper-class="tablePop"
            placement="top"
            width="270"
            :ref="row.investigatorName"
            class="mx-4"
            v-if="row.auditStatus"
          >
            <p class="pb-4 flex leading-22">
              <i class="el-icon-error text-red mr-2 mt-1"></i>
              <span>
                <span class="text-red">代理商删除后不可恢复</span>
                <span>，还要继续吗？删除后，代理商需要重新申请加入</span>
              </span>
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="closeTablePopover()">取消</el-button>
              <el-button type="danger" size="mini" @click="delItemData(row)">删除</el-button>
            </div>
            <el-button type="text" slot="reference" :disabled="!isAdmin">删除</el-button>
          </el-popover>

          <el-tooltip content="仅企业管理员可审核" placement="top" effect="light" :disabled="isAdmin" v-else>
            <div class="inline-block">
              <el-button type="text" @click="handleEditDrawer(row, 'audit')" :disabled="!isAdmin">审核</el-button>
            </div>
          </el-tooltip>
        </template>

        <template #page-left>
          <el-button type="primary" @click="exportAgent" class="mr-3">导出</el-button>
          <el-popover placement="top" width="270" v-model="popoverFlag">
            <p class="pb-4 flex leading-22">
              <i class="el-icon-error text-red mr-2 mt-1"></i>
              <span>
                <span class="text-red">代理商删除后不可恢复</span>
                <span>，还要继续吗？删除后，代理商需要重新申请加入</span>
              </span>
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="popoverFlag = false">取消</el-button>
              <el-button type="danger" size="mini" @click="delData">删除</el-button>
            </div>
            <el-button type="danger" plain slot="reference" :disabled="!isAdmin">删除</el-button>
          </el-popover>
        </template>
      </data-table>
    </div>

    <!-- 邀请代理商的抽屉 -->
    <el-drawer title="代理商信息收集表" size="65%" :visible.sync="drawerFlag" direction="rtl" :before-close="handleDrawer">
      <CollectAgentInfo v-if="drawerFlag" :isAdmin="isAdmin" />
    </el-drawer>

    <!-- 编辑代理商的抽屉 -->
    <el-drawer
      :title="editDrawerTitle"
      size="65%"
      :visible.sync="editDrawerFlag"
      direction="rtl"
      :before-close="handleEditDrawer"
    >
      <EditAgent :type="editType" :close="handleEditDrawer" :answerId="editAnswerId" :getData="getData" />
    </el-drawer>
  </div>
</template>

<script>
import EditAgent from './EditAgent'
import EmptyDetail from './EmptyDetail'
import GlobalConfig from '@/global/config'
import { getFreeLink } from '@/api/wenjuan/publish'
import Status from '@/components/base/Status'
import CollectAgentInfo from './CollectAgentInfo'
import DataTable from '@/components/base/DataTable'
import { getTableHeader, getOrInitAgentSurvey, deleteTable, searchAgent, exportAgent } from '@/api/more-app/agent-base'

export default {
  name: 'AgentDetail',
  components: { EmptyDetail, DataTable, Status, CollectAgentInfo, EditAgent },
  data() {
    return {
      isEmpty: false,
      surveyId: '',
      inputVal: '',
      selectVal: '',
      selectOpt: [
        {
          value: 0,
          label: '待审核'
        },
        {
          value: 1,
          label: '已通过'
        },
        {
          value: 2,
          label: '已拒绝'
        }
      ],
      status: {
        0: '待审核',
        1: '已通过',
        2: '已拒绝'
      },
      tableLoading: false,
      tableHeight: 'calc(100vh - 251px)', // 表格的高度
      page: {
        pageSizes: [10, 20, 30, 40, 50, 100],
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      tableData: [],
      columns: [
        {
          label: '操作',
          value: 'operation',
          align: 'left',
          width: '125px',
          fixed: 'right'
        }
      ],
      drawerFlag: false, // 控制抽屉的显隐
      editDrawerFlag: false, // 控制编辑抽屉的显隐
      popoverFlag: false, // 删除提示的显隐
      editType: '', // 编辑代理商抽屉的显示类型
      answerIdList: [],
      editAnswerId: '', //编辑答卷的答卷id
      editDrawerTitle: '',
      notShowCollectAgentDialog: false
    }
  },
  filters: {
    textColor(val) {
      if (val === 0) {
        return '#FAAD14'
      } else if (val === 1) {
        return '#00BE6A'
      } else if (val === 2) {
        return '#E34152'
      }
    }
  },
  computed: {
    isAdmin() {
      if (GlobalConfig.getCompanyId() == 0 || this.$store.getters.userInfo?.isAdmin == 1) {
        return true
      } else if (this.$store.getters.userInfo?.isAdmin != 1) {
        return false
      }
    }
  },
  methods: {
    // 抽屉开关的事件
    handleDrawer() {
      if (this.notShowCollectAgentDialog) {
        this.$message.error('请先配置代理商信息')
        return
      }
      this.drawerFlag = !this.drawerFlag
      if(!this.drawerFlag) this.getData()
    },
    // 编辑/审核 抽屉开关的事件
    handleEditDrawer(row, str) {
      if (str) this.editType = str
      if (row) this.editAnswerId = row.answerId
      if (str === 'audit') {
        this.editDrawerTitle = row.companyName
      } else if (str === 'edit') {
        this.editDrawerTitle = '编辑代理商'
      }

      this.editDrawerFlag = !this.editDrawerFlag
      if(!this.editDrawerFlag) this.getData()
    },
    // 关闭表格的删除弹窗
    closeTablePopover() {
      document.body.click()
    },
    // 检查是否勾选数据
    checkSelectNUm() {
      if (this.answerIdList.length === 0) {
        this.$message.error('请先勾选数据')
        return false
      } else {
        return true
      }
    },
    // 导出表格数据
    exportAgent() {
      // 判断是否勾选数据
      if (!this.checkSelectNUm()) return false
      this.exportMessage()
      let data = {
        answerIds: this.answerIdList,
        surveyId: GlobalConfig.getSurveyId()
      }
      exportAgent(data)
        .then(res => {
          let blob = new Blob([res.data], { type: 'text/xls' })
          let csvUrl = URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = csvUrl
          link.download = '代理商详情' + '.xlsx'
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(csvUrl)
        })
        .catch(err => {
          console.log(err)
        })
    },
    exportMessage() {
      const h = this.$createElement
      this.$message({
        message: h('p', null, [
          h('p', null, '导出文件生成中'),
          h('p', null, '正在生成代理商文件，文件生成后浏览器将自动下载，请注意查收'),
          h(
            'button',
            {
              on: {
                click: this.messageClose
              }
            },
            '我知道了'
          )
        ]),
        position: 'bottom-left',
        customClass: 'el-message-box_style',
        type: 'success',
        showClose: true,
        offset: 250,
        duration: 0
      })
    },
    messageClose() {
      this.$message.closeAll()
    },
    // 删除单条数据
    delItemData(row) {
      const params = {
        answerIds: row.answerId,
        surveyId: this.surveyId
      }
      deleteTable(params)
        .then(res => {
          this.closeTablePopover()
          this.popoverFlag = false
          if (res.data.code !== 0) {
            if (res.data.code === 1) {
              this.$message.error(res.data.msg)
            }
            return
          }
          this.$refs.dataTable.clearSelection()
          this.getData()
          this.$message.success(res.data.data)
        })
        .catch(err => console.log(err))
    },
    // 删除批量表格数据
    delData() {
      // 判断是否勾选数据
      if (!this.checkSelectNUm()) return false
      let obj = {
        answerId: this.answerIdList.join(',')
      }
      this.delItemData(obj)
    },
    // 表格选择事件
    selectionChange(val) {
      this.answerIdList = val.map(item => {
        return item.answerId
      })
    },
    sizeChange(val) {
      this.page.pageSize = val
      this.getData()
    },
    currentChange(val) {
      this.page.currentPage = val
      this.getData()
    },
    // 表格搜索事件,获取表格数据
    getData() {
      this.tableLoading = true
      let params = {
        enterpriseName: this.inputVal,
        auditStatus: this.selectVal,
        size: this.page.pageSize,
        current: this.page.currentPage,
        descs: 'create_time'
      }
      searchAgent(params)
        .then(res => {
          if (res.data.code !== 0) {
            return
          }
          this.tableData = []
          this.page.total = res.data.data.total
          if (res.data.data.total === 0) {
            this.isEmpty = true
          } else {
            this.isEmpty = false
          }
          // 管理表格的表头和列表信息
          let data = res.data.data.records
          this.columns = [
            {
              label: '操作',
              value: 'operation',
              align: 'left',
              width: '125px',
              fixed: 'right'
            }
          ]
          // 表头信息
          const tableHead = data.slice(0, 1)[0]
          for (let i in tableHead) {
            const obj = {
              label: tableHead[i],
              value: tableHead[i] + i,
              align: 'center',
              width: 150
            }
            // 对于几个特殊表头的处理
            if (obj.label === '企业名称') {
              obj.value = 'companyName'
              obj.fixed = 'left'
            }
            if (obj.label === '添加时间') {
              obj.width = 180
              obj.sortable = true
            }
            if (obj.label === '审核状态') {
              obj.value = 'auditStatus'
            }
            this.columns.splice(i, 0, obj)
          }
          // 列表信息
          data.splice(0, 1)
          data.forEach(item => {
            let obj = {}
            this.columns.forEach((v, index) => {
              if (v.value === 'operation') {
                // 转换一下，最后一个字段是answerId
                obj['answerId'] = item[index]
              } else {
                obj[v.value] = item[index]
              }
            })
            this.tableData.push(obj)
          })
          if (!this.isEmpty) {
            this.$nextTick(() => {
              this.$refs.dataTable.doLayout()
            })
          }
          this.tableLoading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取代理商问卷状态
    async getSurveyState() {
      const params = {
        channelType: '0',
        surveyId: GlobalConfig.getSurveyId()
      }
      await getFreeLink(params)
        .then(res => {
          if (res.data.data.length <= 0) {
            this.notShowCollectAgentDialog = true
          } else {
            this.notShowCollectAgentDialog = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取问卷id
    async getSurveyId() {
      await getOrInitAgentSurvey()
        .then(res => {
          if (res.data.code !== 0) {
            return
          }
          this.surveyId = res.data.data.id
          GlobalConfig.setSurveyId(res.data.data.id)
          GlobalConfig.setSurveyTitle(res.data.data.title)
          this.getData()
          this.getSurveyState() // 获取代理商答卷信息,用于发出提示消息
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created() {
    this.tableLoading = true
    this.getSurveyId() // 获取SurveyId
  },
  beforeDestroy() {
    GlobalConfig.setSurveyId(null)
  }
}
</script>

<style scoped lang="scss">
.agent-detail {
  @apply relative;
  .search-box {
    @apply flex justify-between;
  }
  ::v-deep .items-center {
    @apply justify-center;
  }
}
</style>
<style lang="scss">
.el-message-box_style {
  @apply items-start;
  .el-message__icon {
    @apply text-medium-x mt-0.5 mr-4;
  }
  .el-message__closeBtn {
    top: 20%;
  }
  & > p {
    p:nth-child(1) {
      @apply text-medium-x text-theme-black-850 pb-3;
    }
    p:nth-child(2) {
      @apply text-medium text-theme-black-650 pb-3;
    }
    button {
      @apply bg-transparent text-theme cursor-pointer;
    }
  }
}
</style>
